import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  API_BASE_URL,
  CREATE_USER,
  directToken,
  LIST_OF_AREA,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  Roles_DropDown,
} from "../services/end_points";
import axios from "axios";
import { _post } from "../services/service_api";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

const AddUser = ({ updateUserList }) => {
  const [check, setCheck] = useState(false);
  const [hos, setHos] = useState(false);
  const [checkCity, setCheckCity] = useState(false);
  const [hosName, setHosName] = useState(false);
  const [checkHos, setCheckHos] = useState(false);
  const [alert, setAlert] = useState(null);
  const [ErrorMessage, setErrorMessage] = useState();
  const [selectedArea, setSelectedArea] = useState([]);
  const [filterAreas, setFilterAreas] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState([]);
  const [filterHospitals, setFilterHospitals] = useState([]);
  const [hospitalOption, setHospitalOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const userId = localStorage.getItem("userid");

  const [formdata, setFormData] = useState({
    userName: "",
    email: "",
    password: "",
    repassword: "",
    roleId: "",
    hospital: null,
    city: null,
    area: null,
    limit: null,
  });
  const [usertype, setUsertype] = useState([]);
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleNumericChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      limit: value,
    }));
  };
  const handleRoleChange = (value, option) => {
    const selectedRole = option.label; // Get the selected role

    // Update form data with the selected role ID
    setFormData((prevData) => ({
      ...prevData,
      roleId: value,
    }));

    // Reset all state variables
    setCheck(false);
    setCheckHos(false);
    setCheckCity(false);
    setHos(false);
    setHosName(false);

    // Set state based on the selected role
    if (selectedRole === "front office") {
      setCheckHos(true);
      setCheckCity(true);
      setCheck(true);
    }

    if (selectedRole === "doctor") {
      setHos(true);
    }

    if (selectedRole === "hospital") {
      setHosName(true);
    }
  };

  useEffect(() => {
    fetchData();
    getArea();
    getCity();
    getHospital();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${Roles_DropDown}${userId}`
      );
      if (response.data && response.data.list) {
        setUsertype(
          response.data.list.map((source) => ({
            label: source.userType,
            value: source.id,
          }))
        );
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error.message);
    }
  };

  const getArea = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_AREA}`, {
        headers,
      });
      const data = await response.json();

      setSelectedArea(data.list);
    } catch (error) {
      console.error("Error fetching areas:", error);
    }
  };

  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );
      const data = await response.json();
      setHospitalOption(
        data.list.map((source) => ({
          label: source.hospitalName,
          value: source.id,
        }))
      );

      setSelectedHospital(data.list);
    } catch (error) {
      console.error("Error fetching Hospital Names:", error);
    }
  };
  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });
      const data = await response.json();
      setCityOption(
        data.list.map((source) => ({ label: source.city, value: source.id }))
      );
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let dataToSend = {}; // Initialize dataToSend

    if (formdata.roleId === 2) {
      // Doctor
      const { repassword, area, city, ...rest } = formdata; // Exclude area and city
      dataToSend = rest; // Assign to dataToSend
    } else if (formdata.roleId === 1) {
      // Admin
      const { repassword, area, city, hospital, ...rest } = formdata; // Exclude area and city for admin
      dataToSend = rest; // Assign to dataToSend
    } else if (formdata.roleId === 3) {
      // Hospital
      const { repassword, area, city, ...rest } = formdata; // Exclude area and city for hospital
      dataToSend = rest; // Assign to dataToSend
    } else {
      // Validation for other roles
      if (formdata.password !== formdata.repassword) {
        setErrorMessage("Passwords do not match.");
        return;
      }
      const { repassword, ...rest } = formdata; // Include all necessary fields
      dataToSend = rest; // Assign to dataToSend
    }

    // Post data to the server
    try {
      const response = await _post(`${API_BASE_URL}${CREATE_USER}`, dataToSend);

      // Reset form data
      updateUserList(response.data);
      setFormData({
        userName: "",
        email: "",
        password: "",
        repassword: "",
        roleId: "",
        hospital: "",
        limit: null,
        city: "",
        area: "",
      });

      if (response.status === 201) {
        setAlert(true);
      }
      setTimeout(() => {
        setAlert(false);
      }, 2000);
    } catch (err) {
      console.error("error12", err);
      if (err.data && err.data.error) {
        setErrorMessage(err.data.error); // Set the error message from the response
      } else {
        setErrorMessage("Failed to create user."); // Generic error message
      }
    }
  };
  return (
    <>
      <Form layout="vertical">
        <div style={{ marginTop: "20px" }}>
          {ErrorMessage && (
            <div marginBottom="20px">
              <Alert
                type="error"
                style={{ backgroundColor: "#ff4d4f", color: "white" }} // Customize the style as needed
                message={ErrorMessage}
              />
            </div>
          )}
          {alert && (
            <div marginBottom="20px">
              <Alert
                type="success"
                style={{
                  backgroundColor: "#dbffb8cf",
                  color: "black",
                  width: "100%",
                  marginTop: "0.5rem",
                  marginBottom: "2rem",
                }}
                message={"User Created!"}
              />
            </div>
          )}
        </div>
        <Row gutter={16} style={{ display: "flex", alignItems: "center" }}>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Name" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Name"
                name="userName"
                value={formdata.userName}
                onChange={handleFormChange}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Email" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Email"
                name="email"
                value={formdata.email}
                onChange={handleFormChange}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Password" required>
              <Input.Password
                style={{ height: "40px", width: "100%" }}
                required
                name="password"
                value={formdata.password}
                onChange={handleFormChange}
                size="large"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
        >
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Re-Password" required>
              <Input
                style={{
                  width: "100%",
                  height: "40px",
                }}
                required
                id="re-password"
                name="repassword"
                value={formdata.repassword}
                onChange={handleFormChange}
                type="password"
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Select Role" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="roleId"
                value={formdata.roleId || undefined}
                onChange={handleRoleChange}
                options={usertype}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hos && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      // marginTop: "2px",
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={hospitalOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
        >
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hosName && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={hospitalOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hosName && (
              <div>
                <Form.Item label="Limit OF Users" required>
                  <InputNumber
                    min={1}
                    max={100000}
                    style={{
                      // marginTop: "/2px",
                      width: "100%",
                      height: "40px",
                    }}
                    value={formdata.limit}
                    name="limit"
                    onChange={handleNumericChange}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>
        <Row gutter={16} style={{ display: "flex", alignItems: "center" }}>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {checkCity && (
              <div>
                <Form.Item label="Select City" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="city"
                    value={formdata.city || undefined}
                    onChange={(value) => {
                      setFormData({ ...formdata, city: value });
                      const filteredAreaValue = selectedArea.filter(
                        (city) => city.locationId === value
                      );
                      setFilterAreas(
                        filteredAreaValue.map((source) => ({
                          label: source.area,
                          value: source.id,
                        }))
                      );
                    }}
                    options={cityOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {check && (
              <div>
                <Form.Item label="Select Area" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="area"
                    value={formdata.area || undefined}
                    onChange={(value) => {
                      setFormData({ ...formdata, area: value });

                      const selectedArea2 = selectedArea.find(
                        (area) => area.id === value
                      );

                      if (selectedArea2) {
                        // Filter hospitals based on the selected area's hospitalId
                        const filteredHospitalValue = selectedHospital.filter(
                          (hospital) => hospital.id === selectedArea2.hospitalId // Use selectedArea2 here to access hospitalId
                        );
                        setFilterHospitals(
                          filteredHospitalValue.map((hospital) => ({
                            label: hospital.hospitalName,
                            value: hospital.id,
                          }))
                        );
                      }
                    }}
                    options={filterAreas}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {checkHos && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={filterHospitals}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <Button
            type="button"
            onClick={() =>
              setFormData({
                userName: "",
                email: "",
                password: "",
                repassword: "",
                roleId: "",
                hospital: "",
                city: "",
                area: "",
              })
            }
            style={{
              color: "black",
              border: "solid #1236fa",
              marginRight: "auto",
              width: "85px",
              height: "32px",
              borderRadius: "3vw",
            }}
          >
            Reset
          </Button>
          <Button
            type="submit"
            onClick={handleSubmit}
            style={{
              color: "white",
              background: "#1236fa",
              width: "85px",
              height: "32px",
              borderRadius: "3vw",
            }}
          >
            Submit
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddUser;
